import {IContent} from "../../HubFramework"
import DOOPDocumentation from "./Tabs/DOOPDocumentation";
import Overview from "./Tabs/Overview";
import Configuration from "./Tabs/Configuration";
import EditUsers from "./Tabs/EditUsers";
import {odxIconSets} from "../../OdxComponents/constants";

/**
 * The content of the module
 * This is mandatory for every module. It contains all the information about the module.
 */
export const moduleContent: IContent = {
    moduleName: "doopProd",
    title: "DOOP",
    pages: [
        {
            displayName: "Orders",
            contentPage: Overview,
            icon: {
                name: "shoppingcart",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Configuration",
            contentPage: Configuration,
            icon: {
                name: "config",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "User Management",
            contentPage: EditUsers,
            icon: {
                name: "user-administration",
                iconSet: odxIconSets.core
            },
        },
        // {
        //     displayName: "Logs",
        //     contentPage: Logs
        // },
        {
            displayName: "Documentation",
            contentPage: DOOPDocumentation,
            icon: {
                name: "document-settings",
                iconSet: odxIconSets.core
            },
        }
    ],
    creationProps: [
        {
            displayName: "Order Number",
            name: "DefaultOrderNumber",
            type: "string",
            description: "The default order number",
            value: "",
        },
        {
            displayName: "Default Price Model",
            name: "DefaultPriceModel",
            type: "string",
            description: "The default price model",
            value: "",
        },
    ],
    defaultPage: "Orders",
};
